import FeatureDetailPage from "./FeatureDetailPage";
import { Briefcase } from "lucide-react";
import orgIllustration from "./assets/org-illustration.svg";
const OrganisationDetails = () => {
  return (
    <FeatureDetailPage
      icon={<Briefcase size={32} className="text-blue-400" />}
      title="Communities"
      description="Gain a bird's-eye view of your entire operation. TimeWise allows you to build and manage a clear hierarchy of your business, from the main organization down to individual resources."
      imageSrc={orgIllustration} // Replace with your actual image path
      benefits={[
        "Structure your business with branches and departments.",
        "Assign and manage bookable resources like meeting rooms or equipment.",
        "Provide a clear organizational chart for all team members.",
        "Simplify administrative overhead with a centralized system.",
      ]}
    />
  );
};

export default OrganisationDetails;
